import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RouteTracker } from "./components/RouteTracker";

import Home from "./pages/Home";
import Competitions from "./pages/Competitions";
import CompetitionDetail from "./pages/CompetitionDetail";
import Spin from "./pages/Spin";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import MyTickets from "./pages/MyTickets";
import WalletPage from "./pages/Wallet";
import Members from "./pages/Members";
import Profile from "./pages/Profile";
import { LegalHub, LegalDocPage } from "./pages/Legal";
import Winners from "./pages/Winners";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminLaunch from "./pages/admin/AdminLaunch";
import AdminSiteControl from "./pages/admin/AdminSiteControl";
import AdminStaff from "./pages/admin/AdminStaff";
import AdminSeo from "./pages/admin/AdminSeo";
import AdminPricingLab from "./pages/admin/AdminPricingLab";
import AdminCompetitions from "./pages/admin/AdminCompetitions";
import AdminMarketing from "./pages/admin/AdminMarketing";
import AdminContent from "./pages/admin/AdminContent";
import AdminVerifications from "./pages/admin/AdminVerifications";
import AdminCashouts from "./pages/admin/AdminCashouts";
import AdminExpenses from "./pages/admin/AdminExpenses";
import AdminDiscounts from "./pages/admin/AdminDiscounts";
import AdminSubscriptions from "./pages/admin/AdminSubscriptions";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAuditLogs from "./pages/admin/AdminAuditLogs";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminSecurity from "./pages/admin/AdminSecurity";
import AdminFinance from "./pages/admin/AdminFinance";
import AdminSpinWheel from "./pages/admin/AdminSpinWheel";
import AdminReferrals from "./pages/admin/AdminReferrals";
import AdminHeroStudio from "./pages/admin/AdminHeroStudio";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" richColors closeButton />
      <AuthProvider>
        <SiteConfigProvider>
          <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/competitions" element={<Competitions />} />
              <Route path="/category/:category" element={<Competitions />} />
              <Route path="/competitions/:id" element={<CompetitionDetail />} />
              <Route path="/spin" element={<ProtectedRoute><Spin /></ProtectedRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/members" element={<Members />} />
              <Route path="/legal" element={<LegalHub />} />
              <Route path="/legal/:slug" element={<LegalDocPage />} />
              <Route path="/winners" element={<Winners />} />
              <Route path="/my-tickets" element={<ProtectedRoute><MyTickets /></ProtectedRoute>} />
              <Route path="/wallet" element={<ProtectedRoute><WalletPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminOverview />} />
                <Route path="site-control" element={<AdminSiteControl />} />
                <Route path="launch" element={<AdminLaunch />} />
                <Route path="seo" element={<AdminSeo />} />
                <Route path="pricing-lab" element={<AdminPricingLab />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="finance" element={<AdminFinance />} />
                <Route path="spin-wheel" element={<AdminSpinWheel />} />
                <Route path="referrals" element={<AdminReferrals />} />
                <Route path="hero-studio" element={<AdminHeroStudio />} />
                <Route path="security" element={<AdminSecurity />} />
                <Route path="staff" element={<AdminStaff />} />
                <Route path="competitions" element={<AdminCompetitions />} />
                <Route path="marketing" element={<AdminMarketing />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="verifications" element={<AdminVerifications />} />
                <Route path="cashouts" element={<AdminCashouts />} />
                <Route path="expenses" element={<AdminExpenses />} />
                <Route path="discounts" element={<AdminDiscounts />} />
                <Route path="subscriptions" element={<AdminSubscriptions />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="audit-logs" element={<AdminAuditLogs />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
        </SiteConfigProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
